import getConfig from 'next/config'

const STAGING_HOST_MARKER = 'dev-bitrix.by'
const PRODUCTION_HOSTS = ['elemental.ae', 'www.elemental.ae']

function getHost() {
  const host = getConfig()?.publicRuntimeConfig?.host || ''

  return host.replace(/^https?:\/\//, '').split('/')[0].split(':')[0]
}

export default function isStaging() {
  const host = getHost()

  if (!host || PRODUCTION_HOSTS.includes(host)) {
    return false
  }

  return host.includes(STAGING_HOST_MARKER)
}
